import * as React from 'react';
import { Column } from '../../types';

type CountMap = {
  completed?: number;
  waitinglist?: number;
  signup?: number;
  departmentsignup?: number;
  assigned?: number;
}

type ResultTableProps = {
  item: CountMap;
  columns: Column[];
};

const ResultTableTotalCell = ({ columns, item }: ResultTableProps) => {
  const counts = React.useMemo(() => {
    return columns.reduce((map: CountMap, key) => {
      return { ...map, [key]: item[key] };
    }, {});
  }, [columns, item]);

  return (
    <div className="flex">
      {counts.waitinglist !== undefined && (
        <div className="tr">
          <div className="f7 uppercase">Venteliste</div>
          <span className="tabular-nums">{counts.waitinglist}</span>
        </div>
      )}
      {counts.assigned !== undefined && (
        <div className="tr ml-3">
          <div className="f7 uppercase">Tilmeldt</div>
          <span className="tabular-nums">{counts.assigned}</span>
        </div>
      )}
      {counts.departmentsignup !== undefined && (
        <div className="tr ml-3">
          <div className="f7 uppercase">Afd.ansøgning</div>
          <span className="tabular-nums">{counts.departmentsignup}</span>
        </div>
      )}
      {counts.signup !== undefined && (
        <div className="tr ml-3">
          <div className="f7 uppercase">Ansøgning</div>
          <span className="tabular-nums">{counts.signup}</span>
        </div>
      )}
      {counts.completed !== undefined && (
        <div className="tr ml-3">
          <div className="f7 uppercase">Gennemført</div>
          <span className="tabular-nums">{counts.completed}</span>
        </div>
      )}
    </div>
  );
};

export default ResultTableTotalCell;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ResultTable/TotalCell.tsx